<template>
    <v-app-bar app color="primary" class="d-print-none" dark clipped-left style="z-index: 100">
        <v-app-bar-nav-icon
            @click="$emit('input', !drawer)"
            v-if="$store.isExpire()"
        ></v-app-bar-nav-icon>
        <div class="d-flex align-center">
            <v-card-title>CoMS</v-card-title>
        </div>

        <v-spacer></v-spacer>

        <v-menu offset-y v-if="$store.isExpire()">
            <template v-slot:activator="{ on, attrs }">
                <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-account-circle</v-icon>
                </v-btn>
            </template>

            <v-list>
                <v-list-item v-for="item in usermenus" :key="item.name" :to="item.link">
                    <v-list-item-content>{{ item.name }}
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
export default {
  name: "header_bar",
  props: ["drawer"],
    data() {
        return {
            usermenus: [
                {
                    name: "ログアウト",
                    link: "/logout",
                },
            ]
        };
    }
};
</script>